"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _generalStore = _interopRequireDefault(require("general-store"));

var _dispatcher = _interopRequireDefault(require("dispatcher/dispatcher"));

var _LinkedSalesObjectActions = _interopRequireDefault(require("crm_ui/flux/integrations/LinkedSalesObjectActions"));

var _LinkedSalesObjectActionTypes = _interopRequireDefault(require("crm_ui/flux/integrations/LinkedSalesObjectActionTypes"));

var FETCH_SUCCEEDED = _LinkedSalesObjectActionTypes.default.FETCH_SUCCEEDED,
    FETCH_FAILED = _LinkedSalesObjectActionTypes.default.FETCH_FAILED;

var _data = new _immutable.Map();

var _default = _generalStore.default.define().defineGet(function (_ref) {
  var objectTypeId = _ref.objectTypeId,
      associatedObjectId = _ref.associatedObjectId,
      associatedObjectType = _ref.associatedObjectType;

  if (!_data.hasIn([associatedObjectType, associatedObjectId, objectTypeId])) {
    _data = _data.setIn([associatedObjectType, associatedObjectId, objectTypeId], new _immutable.Map({
      content: null,
      error: false
    }));

    _LinkedSalesObjectActions.default.fetch({
      objectTypeId: objectTypeId,
      associatedObjectId: associatedObjectId,
      associatedObjectType: associatedObjectType
    });
  }

  return _data;
}).defineResponseTo(FETCH_SUCCEEDED, function (_ref2) {
  var objectTypeId = _ref2.objectTypeId,
      associatedObjectId = _ref2.associatedObjectId,
      associatedObjectType = _ref2.associatedObjectType,
      content = _ref2.content;
  _data = _data.setIn([associatedObjectType, associatedObjectId, objectTypeId], new _immutable.Map({
    content: content,
    error: false
  }));
}).defineResponseTo(FETCH_FAILED, function (_ref3) {
  var objectTypeId = _ref3.objectTypeId,
      associatedObjectId = _ref3.associatedObjectId,
      associatedObjectType = _ref3.associatedObjectType;
  _data = _data.setIn([associatedObjectType, associatedObjectId, objectTypeId, 'error'], true);
}).register(_dispatcher.default);

exports.default = _default;
module.exports = exports.default;